module.exports = __webpack_public_path__ + "static/media/reset_pw.ca6b0f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/forgot_password/reset_pw.png
// module id = 1030
// module chunks = 0